import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Login from './pages/Login';
import Signup from './pages/Signup';
import HomePage from './pages/HomePage';
import WebHomepage from './pages/WebHomepage';
import Layout from './layout';
import ResetPassword from './pages/ResetPassword';
import CreatePassword from './pages/CreatePassword';
import WebLayout from './weblayout';
import WhyPovego from './pages/WhyPovego';
import HowItWorks from './pages/HowItWorks';
import Products from './pages/Products';
import Operation from './pages/Operation';
import AboutUs from './pages/AboutUs';
import WhatIsPovego from './pages/WhatIsPovego';
import Team from './pages/Team';
import Personal from './pages/Personal';
import Declaration from './pages/Declaration';
import Usage from './pages/Usage';
import Cookies from './pages/Cookies';
import Deposit from './components/Deposit';
import Withdraw from './components/Withdraw';
import KYCPage from './pages/KYCPage';
import Settings from './components/Settings';
import Notification from './components/Notification';
import { useSelector } from 'react-redux';
import Swap from './components/HomeComponent/Swap';

function Router() {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return (
    <div>
      <Routes>
        <Route path='/' element={<WebLayout><WebHomepage /></WebLayout>} />
        <Route path='/why-povego' element={<WebLayout><WhyPovego /></WebLayout>} />
        <Route path='/how-it-works' element={<WebLayout><HowItWorks /></WebLayout>} />
        <Route path='/what-is-povego' element={<WebLayout><WhatIsPovego /></WebLayout>} />
        <Route path='/team' element={<WebLayout><Team /></WebLayout>} />
        <Route path='/products' element={<WebLayout><Products /></WebLayout>} />
        <Route path='/how-to-trade' element={<WebLayout><Operation /></WebLayout>} />
        <Route path='/cookies' element={<WebLayout><Cookies /></WebLayout>} />
        <Route path='/personal-data' element={<WebLayout><Personal /></WebLayout>} />
        <Route path='/clarification-text' element={<WebLayout><Declaration /></WebLayout>} />
        <Route path='/terms-of-use' element={<WebLayout><Usage /></WebLayout>} />
        <Route path='/about-us' element={<WebLayout><AboutUs /></WebLayout>} />
        <Route path='/neden' element={<Navigate to='/why-povego' replace />} />
        <Route path='/nasil' element={<Navigate to='/how-it-works' replace />} />
        <Route path='/ne' element={<Navigate to='/what-is-povego' replace />} />
        <Route path='/takim' element={<Navigate to='/team' replace />} />
        <Route path='/urunler' element={<Navigate to='/products' replace />} />
        <Route path='/operasyon' element={<Navigate to='/how-to-trade' replace />} />
        <Route path='/cerezler' element={<Navigate to='/cookies' replace />} />
        <Route path='/kisisel' element={<Navigate to='/personal-data' replace />} />
        <Route path='/aydinlatma' element={<Navigate to='/clarification-text' replace />} />
        <Route path='/kullanim' element={<Navigate to='/terms-of-use' replace />} />
        <Route path='/hakkimizda' element={<Navigate to='/about-us' replace />} />
        <Route path='/anasayfa' element={isLoggedIn ? <HomePage /> : <Navigate to='/login' />} />
        <Route path='/anasayfa/:id' element={isLoggedIn ? <HomePage /> : <Navigate to='/login' />} />
        <Route path='/kyc' element={isLoggedIn ? <Layout><KYCPage /></Layout> : <Navigate to='/login' />} />
        <Route path='/login' element={!isLoggedIn ? <Layout><Login /></Layout> : <Navigate to='/anasayfa' />} />
        <Route path='/signup' element={!isLoggedIn ? <Layout><Signup /></Layout> : <Navigate to='/anasayfa' />} />
        <Route path='/kayit' element={<Navigate to='/signup' replace />} />
        <Route path='/reset-password' element={<Layout><ResetPassword /></Layout>} />
        <Route path='/create-password' element={<Layout><CreatePassword /></Layout>} />
        <Route path='/deposit' element={isLoggedIn ? <Layout><Deposit /></Layout> : <Navigate to={'/login'} />} />
        <Route path='/withdraw' element={isLoggedIn ? <Layout><Withdraw /></Layout> : <Navigate to={'/login'} />} />
        <Route path='/parayatırma' element={<Navigate to='/deposit' replace />} />
        <Route path='/paracekme' element={<Navigate to='/withdraw' replace />} />
        <Route path='/anasayfa/ayarlar' element={isLoggedIn ? <Layout><Settings /></Layout> : <Navigate to='/login' />} />
        <Route path='/home/notification' element={<Layout><Notification/></Layout>}/> {/* Ensure this path matches */}
        <Route path='/home/swap' element={<Layout><Swap/></Layout>}/> {/* Ensure this path matches */}
        {/* Add the Settings route here */}
      </Routes>
    </div>
  );
}

export default Router;
